module.exports = __webpack_public_path__ + "static/aloopcolor-0efc84debc6b4b256edc06cf51d0a9bf.png";